import React, { useEffect, useState } from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

interface SearchProps {
  label: string;
  onSearch: (value: string) => void;
  border?: boolean;
  value?: string;
}

const Search: React.FC<SearchProps> = ({
  label,
  onSearch,
  border = false,
  value = null,
}) => {
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      onSearch(searchValue);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue, onSearch]);

  useEffect(() => {
    if (value) {
      setSearchValue(value);
    }
  }, [value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      onSearch(searchValue);
    }
  };

  const handleClear = () => {
    setSearchValue("");
  };

  return (
    <TextField
      variant="outlined"
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: searchValue && (
          <InputAdornment position="end">
            <IconButton
              onClick={handleClear}
              sx={{
                marginRight: "-12px",
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        width: "100%",
        height: "38px",
        border: border ? "1px solid #ccc" : "none",
        "& .MuiInputBase-root": {
          height: "100%",
        },
        background: "#fff",
        borderRadius: "8px",
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: "none",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
          "& .MuiInputBase-input": {
            padding: "8px  14px",
          },
        },
      }}
      value={searchValue}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      placeholder={label}
    />
  );
};

export default Search;
